export enum Role {
    Admin = 'Admin',
    Executive = 'Executive',
    Manager = 'Manager',
}

export enum Level {
    AnalysisTeam = 'Analysis Team',
    BillTeam = 'Bill Team',
    Manager = 'Manager',
    Supervisor = 'Supervisor',
}
